import { axios } from "utils";

import { PUBLIC_COURSES_URL as endpoint } from "consts";

export const getCourses = async (data) => axios.get(`${endpoint}`, { data });

export const getCourseDetails = async (data) => axios.get(`${endpoint}/${data.slug}`, { data });

export const startCourse = async (data) => axios.post(`${endpoint}/${data.slug}/start`, { data });

export const completeModule = async (data) => axios.post(`${endpoint}/modules/${data.moduleId}/complete`, { data });

export const startModule = async (data) => axios.post(`${endpoint}/modules/${data.moduleId}/start`, { data });
